"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

exports.__esModule = true;
exports.generateId = generateId;
exports.resetId = resetId;
var currentId = 0;

function generateId() {
  currentId += 1;
  return currentId.toString();
}

function resetId() {
  currentId = 0;
}